import { DateInput, NumberInput, ReferenceArrayInput, SelectArrayInput, TextInput } from 'react-admin'

const DraftFilters = [
  <TextInput source="companyName_Contains" label="resources.filter.companyNameContains" alwaysOn resettable />,
  <NumberInput source="grossAmount_Gt" label={"resources.filter.grossAmountGt"} alwaysOn />,
  <NumberInput source="grossAmount_Lt" label={"resources.filter.grossAmountLt"} alwaysOn />,
  <DateInput source='dueDate_Gt' label={"resources.filter.dueDateGt"} />,
  <DateInput source='dueDate_Lt' label={"resources.filter.dueDateLt"} />,
  <ReferenceArrayInput source='numberRangeId_Eq' reference='numberRanges' label={"resources.filter.numberRangeIdEq"} alwaysOn >
    <SelectArrayInput label={"resources.filter.numberRangeIdEq"} />
  </ReferenceArrayInput>,
]

export default DraftFilters